var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-portal", [
    _c("div", { staticClass: "help-page mb-4 mx-auto" }, [
      _c("h1", { staticClass: "text-center mb-4" }, [_vm._v("Help")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }